import { monthEndAlertConstants } from '../../actions/constant';

const { GET_LIST_OF_MONTH_REQUEST, GET_LIST_OF_MONTH_SUCCESS, GET_LIST_OF_MONTH_FAILURE } =
  monthEndAlertConstants;

const intitialstate: object = {
  response: null,
  isError: false,
  loading: false,
};

export const getListofMonthEndAlertReducer = (state = intitialstate, action: any) => {
  switch (action.type) {
    case GET_LIST_OF_MONTH_SUCCESS: {
      return {
        ...state,
        isError: false,
        response: action.payload?.data,
        loading: false,
      };
    }
    case GET_LIST_OF_MONTH_FAILURE:
      return {
        ...state,
        isError: true,
        response: null,
        loading: false,
      };
    case GET_LIST_OF_MONTH_REQUEST:
      return {
        ...state,
        loading: true,
        isError: false,
      };
    default:
      return state;
  }
};
